/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2026 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

/**
 * Split out of CART_FRAGMENT: the free-gift catalog payload (products,
 * configurable options, bundle items) is heavy and only needed when the
 * gift picker is shown, so it is fetched lazily via its own query instead
 * of on every cart operation (add to cart, apply coupon, etc.).
 */
export const AVAILABLE_FREE_GIFTS_FRAGMENT = /* GraphQL */ `
  fragment AVAILABLE_FREE_GIFTS_FRAGMENT on Cart {
    available_free_gifts {
      rule_id
      rule_label
      gift_qty
      available_skus
      products {
        __typename
        sku
        name
        thumbnail {
          url
          label
        }
        ... on ConfigurableProduct {
          configurable_options {
            uid
            attribute_uid
            label
            values {
              uid
              label
            }
          }
        }
        ... on BundleProduct {
          items {
            uid
            title
            required
            type
            position
            sku
            price_range {
              minimum_price {
                final_price {
                  value
                  currency
                }
                regular_price {
                  value
                  currency
                }
              }
              maximum_price {
                final_price {
                  value
                  currency
                }
                regular_price {
                  value
                  currency
                }
              }
            }
            options {
              uid
              quantity
              position
              is_default
              label
              can_change_quantity
              product {
                uid
                name
                sku
                __typename
              }
            }
          }
        }
      }
    }
  }
`;
